// src/Component/FloatingCartButton.js
import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const FloatingCartButton = ({ count }) => {
    const navigate = useNavigate();

    if (count === 0) return null;

    return (
        <div className="floating-cart-button slide-in-bottom" onClick={() => navigate('/cart')}>
            <ShoppingCart size={24} />
            <span className="cart-badge">{count}</span>
        </div>
    );
};

export default FloatingCartButton;
